/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import { CompanyAgreement, UserAgreement } from '../reducers/current-user';
import { ProductCodes } from '../services/SubscriptionService';
import { SurveyOverviewMode } from '../slice/surveySettings';
import { OnboardingStep } from './onboarding';

export interface AgreementConfig<T = UserAgreement> {
  code: T;
  fromDate?: Date;
}

export enum AppCode {
  WWG = 'wwg',
  SGXESGenome = 'sgx_esgenome',
  CompanyTrackerStarter = 'company_tracker_starter',
  CompanyTracker = 'company_tracker_light',
  CompanyTrackerPro = 'company_tracker_pro',
  CompanyTrackerEnterprise = 'company_tracker_enterprise',
  PortfolioTrackerExchange = 'portfolio_tracker_exchange',
  PortfolioTrackerExchangeSGX = 'portfolio_tracker_exchange_sgx',
}

export interface AppConfig {
  code: AppCode;
  productCode: ProductCodes;
  validProductCodes: ProductCodes[];

  // App Setup
  name: string;
  logo: string;
  rootAppPath: string;
  onboardingPath: string;

  /** Overall website change **/
  whitelabel?: {
    logo?: string;
  };
  /** App specific changes **/
  settings: {
    defaultSurveyOverviewMode?: SurveyOverviewMode;

    /**
     * Used by question progress circles to determine what to display or "add" to scope
     * Note: used to be only used when company is CTL, now is respected.
     */
    overviewRecommendedAddons: string[];

    /**
     * Determine what appears at the top of scope view (core packs)
     * Also used the preferred alternative codes for SDG Contributions
     * detail view, question list and insight references etc.
     * The order is important
     **/
    settingsRecommendedAddons: string[];

    /**
     * All of these codes will be split to free and premium groups and displayed
     * as option to add to the scope
     */
    availableAddons?: string[];
    requiresTermsAndConditions?: boolean;
    onboardingSteps?: OnboardingStep[];
    userAgreementsRequired?: AgreementConfig<UserAgreement>[];
    companyAgreementsRequired?: AgreementConfig<CompanyAgreement>[];
    canViewAllPacks?: boolean;
    canEditInsightOverview?: boolean;
    canShowSDGDetails?: boolean;
  };
}
